package br.com.vvrefeicoes.portal.feature.purchases

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.AppButton
import br.com.vvrefeicoes.portal.core.ui.components.AppModalCard
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.core.ui.components.PortalButtonVariant
import br.com.vvrefeicoes.portal.core.ui.theme.AppSpacing
import br.com.vvrefeicoes.portal.core.util.MoneyFormatter
import br.com.vvrefeicoes.portal.core.util.MonthCalendar
import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import br.com.vvrefeicoes.portal.domain.model.PurchasesProvision
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.compras_action_cancel
import portalvv.shared.generated.resources.compras_action_save
import portalvv.shared.generated.resources.compras_provision_label
import portalvv.shared.generated.resources.compras_provision_period
import portalvv.shared.generated.resources.compras_provision_title

@Composable
fun PurchasesProvisionDialog(
    period: MonthPeriod,
    provision: PurchasesProvision?,
    saving: Boolean,
    onDismiss: () -> Unit,
    onSave: (Long) -> Unit,
) {
    var amount by remember(period, provision) {
        mutableStateOf(
            provision
                ?.takeIf { it.configured }
                ?.let { MoneyFormatter.formatCents(it.amountCents) }
                .orEmpty(),
        )
    }
    val parsed = MoneyFormatter.parseReaisToCents(amount)
    val canSave = parsed != null && parsed >= 0L && !saving

    AppModalCard(title = stringResource(Res.string.compras_provision_title), onDismiss = onDismiss) {
        Column(
            modifier = Modifier.fillMaxWidth().widthIn(max = 420.dp),
            verticalArrangement = Arrangement.spacedBy(AppSpacing.space16),
        ) {
            Text(
                text = stringResource(Res.string.compras_provision_period, MonthCalendar.label(period)),
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
            )
            AppTextField(
                value = amount,
                onValueChange = { amount = it },
                label = stringResource(Res.string.compras_provision_label),
                modifier = Modifier.fillMaxWidth(),
            )
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(AppSpacing.space8, Alignment.End),
            ) {
                AppButton(
                    text = stringResource(Res.string.compras_action_cancel),
                    onClick = onDismiss,
                    variant = PortalButtonVariant.Outlined,
                )
                AppButton(
                    text = stringResource(Res.string.compras_action_save),
                    onClick = { parsed?.let(onSave) },
                    enabled = canSave,
                )
            }
        }
    }
}
